import { TableColumnFormatType as i, TableColumnHashingAlgorithm as t } from "@decentriq/graphql/dist/enums";
var l = /* @__PURE__ */ ((a) => (a[a.All = 0] = "All", a[a.Mapped = 1] = "Mapped", a[a.Unmapped = 2] = "Unmapped", a))(l || {}), r = /* @__PURE__ */ ((a) => (a.All = "all", a.Valid = "valid-only", a.Invalid = "invalid-only", a))(r || {});
const d = "2";
var n = /* @__PURE__ */ ((a) => (a.FormatData = "FormatData", a.AdjustSchema = "AdjustSchema", a.MappedColumns = "MappedColumns", a.FixValues = "FixValues", a.EncryptAndProvision = "EncryptAndProvision", a))(n || {});
export {
  i as FormatType,
  t as HashWith,
  d as LATEST_SCHEMA_VERSION,
  n as NavigatorStepKey,
  l as ShowColumns,
  r as ShowRows
};
//# sourceMappingURL=index.js.map
